import React from "react";

/**
 * Tag Dropdown Component
 * Reusable component for tag selection dropdown
 */
const TagDropdown = ({
  isOpen,
  tagEdit,
  tagQuery,
  onTagInputChange,
  filteredTagItems,
  onTagSelect,
  contentRef,
}) => {
  return (
    <>
      {isOpen && (
        <div className="custom-dropdown" ref={contentRef} onMouseDown={(e) => e.stopPropagation()}>
          <input
            type="text"
            className="search-bar"
            placeholder="Search..."
            value={tagQuery || ""}
            onChange={onTagInputChange}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
            autoComplete="off"
          />
          <ul className="client-list" onMouseDown={(e) => e.stopPropagation()}>
            {filteredTagItems.map((tag) => (
              <li
                className="cursor"
                key={tag._id}
                onClick={(e) => {
                  e.stopPropagation();
                  onTagSelect(tag);
                }}
                onMouseDown={(e) => e.stopPropagation()}
              >
                {tag.tag_name}
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default TagDropdown;
